module.exports = __webpack_public_path__ + "static/media/promo3-1.cbbccf4f.svg";